<style lang="less" scoped>
.query-title-div {
  width: 90px !important;
}
.lang-width {
  width: 450px !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">维修详情列表</div>
      <ZD-list-querys></ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="addRepairFun()">新 增</button> -->
        <button class="common-bg-button" @click="repairFun()">维 修</button>
        <div class="flex-1"></div>
        <el-select
          size="small"
          v-model="queryInfo.repairStatus"
          style="width:320px;margin-right:10px;"
          clearable
        >
          <el-option label="未维修" value="01"></el-option>
          <el-option label="已维修" value="02"></el-option>
        </el-select>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜索
        </button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.repairColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      pagination: pageConfig.pagination,
      // 默认值设置
      detailForm: {},
      queryInfo: {},
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      tableData: [], // 表格数据
      selections: [], // 表格选项
    }
  },
  methods: {
    //h获取表格数据
    init() {
      // this.getFormInfo();
      this.getListData(this.pagination, true)
    },
    // 获取表单信息
    // getFormInfo(){
    //     let _ = this;
    //     _.$S.getFormInfo(_,_.$A.pile.list+'/'+_.$store.state.editId,function(res){
    //          _.detailForm = res.data.data;
    //          _.queryInfo.pileNo = _.detailForm.pileNo;
    //          _.getListData(_.pagination);
    //     });
    // },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pileCode = _.$store.state.editId
      _.queryInfo.pageSize = pagination.pageSize
      _.$H.get(_, _.$A.pile.pilerepair, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    //选择表单
    checkSelectOne() {
      if (this.selections.length < 1) {
        this.$U.error('请选择需要操作的对象')
        return false
      }
      if (this.selections.length > 1) {
        this.$U.error('只能选择一个操作的对象')
        return false
      }
      return true
    },
    //该功能已弃用
    addRepairFun() {
      this.$router.push({
        name: pageConfig.repairAddRouter,
      })
    },
    //维修
    repairFun() {
      if (this.checkSelectOne()) {
        let id = this.selections[0].id
        this.$router.push({
          name: pageConfig.repairRouter,
          params: {
            id: id,
          },
        })
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>
